export function validarSintaxis(tag) {
  const contenido = tag.replace(/^\$\{|\}$/g, '').trim()

  // No puede estar vacío
  if (!contenido) return { ok: false, error: 'Placeholder vacío' }

  // v: e i:
  if (/^(v:|i:)/.test(contenido)) return { ok: true }

  // función estilo imprimePosicion:alias,arg
  if (/^[a-zA-Z0-9_]+:/.test(contenido)) return { ok: true }

  // alias simple (variable o expresión)
  if (/^[a-zA-Z0-9_]+$/.test(contenido)) return { ok: true }

  return { ok: false, error: 'Sintaxis desconocida' }
}
